module.exports = __webpack_public_path__ + "static/media/homes-around-the-world.a314986c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/img/homes-around-the-world.jpg
// module id = 439
// module chunks = 0